import React, {Fragment} from "react";
import { data_z_dniem } from "../../../functions/dataFormat";

import { adresPro, findMieszkanieId } from "../../../functions/ulice";

const MieszkaniecWydrukNaglowek = props => {

    const { udzialyKonta_a, mieszkaniec, lokale, ulice, grupy_a, miesiac } = props;

    const idMieszkania = findMieszkanieId(udzialyKonta_a,grupy_a,lokale);
    const adres = adresPro(idMieszkania,lokale, ulice);

    return (
        <Fragment>
            <section
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: '13px',
                    textAlign: 'left'
                }}
            >
                <div>
                    <span>
                        <b>Administrator Wspólnoty</b><br/>
                        Przedsiębiorstwo Usługowe eM3 s.j.<br/>
                        Biuro Obsługi Nieruchomości<br/>
                        Mojsiewicz & Stanek s.c.<br/>
                        ul. Mieszka I 57/6<br/>
                        66-400 Gorzów Wielkopolski<br/>
                        t: 95 724 19 08, 690 240 779<br/>
                        www.bonadministrator.pl
                    </span>
                </div>
                <div>
                    Gorzów Wlkp. {data_z_dniem()}
                </div>
            </section>
            <section
                style={{
                    display: 'flex',
                    justifyContent: 'right',
                    fontSize: '13px',
                    margin: '20mm 0 0 0'
                }}
            >
                <span
                    style={{
                        fontWeight: '600',
                        fontSize: '14px'
                    }}
                >
                    Sz. P.<br/>
                    {mieszkaniec?.imie_nazwisko}<br/>
                    {adres}<br/>
                    66-400 Gorzów Wlkp.

                </span>
                
            </section>
            <section
                style={{
                    margin: '10mm 0 0 0'
                }}
            >
                <p
                    style={{
                        fontSize: '13px',
                        textAlign: 'left'
                    }}
                >
                    {`Uprzejmie zawiadamiamy, iż wymiar miesięcznej zaliczki na pokrycie kosztów zarządu nieruchomością wspólną oraz zaliczek na poczet mediów i usług dodatkowych w miesiącu ${miesiac} r. wynosi:`}
                </p>
            </section>
        </Fragment>
    )
}

export default MieszkaniecWydrukNaglowek;